import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import useApiStable from '../utils/useApiStable';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [tokenInvalid, setTokenInvalid] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const api = useApiStable();

  if (!token) {
    return (
      <div className="container" style={{ maxWidth: '500px', margin: '50px auto', padding: '0 20px' }}>
        <div style={{ background: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
          <p style={{ color: '#c62828' }}>Ungültiger Link. Bitte fordere einen neuen Reset-Link an.</p>
          <div style={{ textAlign: 'center', marginTop: '16px', fontSize: '0.9em' }}>
            <a href="/forgot-password" style={{ color: '#1976d2', textDecoration: 'none' }}>
              Neuen Reset-Link anfordern
            </a>
          </div>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="container" style={{ maxWidth: '500px', margin: '50px auto', padding: '0 20px' }}>
        <div style={{ background: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
          <h2 style={{ textAlign: 'center', marginBottom: '24px' }}>Passwort geändert</h2>
          <div style={{ background: '#e8f5e9', color: '#2e7d32', padding: '16px', borderRadius: '4px', marginBottom: '24px', fontSize: '0.9em' }}>
            Dein Passwort wurde erfolgreich zurückgesetzt. Du kannst dich jetzt anmelden.
          </div>
          <div style={{ textAlign: 'center', fontSize: '0.9em' }}>
            <a href="/login" style={{ color: '#1976d2', textDecoration: 'none' }}>
              Zum Login
            </a>
          </div>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword.length < 6) {
      setError('Das Passwort muss mindestens 6 Zeichen lang sein.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Die Passwörter stimmen nicht überein.');
      return;
    }

    setLoading(true);
    try {
      await api.fetchRaw('/auth/reset-password', {
        method: 'POST',
        body: JSON.stringify({ token, newPassword }),
      });
      setSuccess(true);
    } catch {
      setError('Der Link ist abgelaufen oder ungültig. Bitte fordere einen neuen an.');
      setTokenInvalid(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container" style={{ maxWidth: '500px', margin: '50px auto', padding: '0 20px' }}>
      <div style={{ background: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>Neues Passwort setzen</h2>

        {error && (
          <div style={{ background: '#ffebee', color: '#c62828', padding: '12px', borderRadius: '4px', marginBottom: '20px', fontSize: '0.9em' }}>
            {error}{' '}
            {(error.includes('abgelaufen') ||  tokenInvalid) && (
              <a href="/forgot-password" style={{ color: '#c62828' }}>
                Neuen Link anfordern
              </a>
            )}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
              Neues Passwort* (mind. 6 Zeichen)
            </label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              minLength={6}
              autoFocus
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '1em',
                boxSizing: 'border-box',
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
              Passwort bestätigen*
            </label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={6}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '1em',
                boxSizing: 'border-box',
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              background: loading ? '#90a4ae' : '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              fontSize: '1em',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontWeight: '500',
            }}
          >
            {loading ? 'Speichern...' : 'Passwort speichern'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
